import { useState } from "react";
import { CheckCircle2, Loader2, XCircle, ChevronDown } from "lucide-react";

export const UpdateSteps = ({ steps, log, running, ok }) => {
  const [open, setOpen] = useState(false);
  const etapes = Array.isArray(steps) ? steps : [];
  const lignes = Array.isArray(log) ? log : [];
  if (etapes.length === 0 && lignes.length === 0) return null;
  const echec = ok === false;
  return (
    <div data-testid="update-steps" className="mt-3 rounded-xl bg-ink p-3">
      <ul className="space-y-1.5">
        {etapes.map((s, i) => {
          const enCours = running && i === etapes.length - 1;
          return (
            <li key={`${i}-${s}`} data-testid={`update-step-${i}`} className="flex items-center gap-2 text-sm text-chalk">
              {enCours ? <Loader2 className="h-4 w-4 shrink-0 animate-spin text-lime" /> : <CheckCircle2 className="h-4 w-4 shrink-0 text-lime" />}
              {s}
            </li>
          );
        })}
        {echec && (
          <li data-testid="update-step-error" className="flex items-center gap-2 text-sm text-red-400">
            <XCircle className="h-4 w-4 shrink-0" /> La mise à jour a échoué. Ouvre le détail ci-dessous.
          </li>
        )}
      </ul>
      {lignes.length > 0 && !echec && (
        <button data-testid="update-log-toggle" onClick={() => setOpen((o) => !o)}
          className="mt-3 inline-flex items-center gap-1 text-xs text-dim transition-colors hover:text-chalk">
          <ChevronDown className={`h-3.5 w-3.5 transition-transform ${open ? "rotate-180" : ""}`} />
          {open ? "Masquer le détail technique" : "Voir le détail technique"}
        </button>
      )}
      {(open || echec) && lignes.length > 0 && (
        <pre data-testid="update-log" className="mt-2 max-h-48 overflow-auto whitespace-pre-wrap rounded-lg bg-pitch p-3 font-mono text-[11px] text-dim">{lignes.join("\n")}</pre>
      )}
    </div>
  );
};
